<div class="px-5 pb-5">
  <h1 class="cbb-page-title mb-4">Centros logísticos</h1>
  <app-centros-logisticos-cemento-tabla></app-centros-logisticos-cemento-tabla>
</div>
